import { createSlice } from '@reduxjs/toolkit';
export const ApiStateSlice = createSlice({
  name: 'ApiStateSlice',
  initialState: {
    recoApi: '',
    riskApi: '',
    filterRecoApi: '',
    filterRiskApi: '',
    recoExportTableData: []
  },
  reducers: {
    pushExportRecommandationApi: (state, action) => {
      state.recoApi = action.payload;
    },
    pushExportRiskApi: (state, action) => {
      state.riskApi = action.payload;
    },
    pushExportFilterRecommandationApi: (state, action) => {
      state.filterRecoApi = action.payload;
    },
    pushExportFilterRiskApi: (state, action) => {
      state.filterRiskApi = action.payload;
    }
  }
});
export const {
  pushExportRecommandationApi,
  pushExportRiskApi,
  pushExportFilterRecommandationApi,
  pushExportFilterRiskApi,
  getApiResponse
} = ApiStateSlice.actions;
export default ApiStateSlice.reducer;